















/* Created- 28 - Mar - 2019 */
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import ActionListV2 from "@/Ui-Components/Common/List/ActionListV2.vue";
// change to business classes you need.
import { INavigationService, NavigationService } from "../NavigationServices/navigation";
import { ListItemDTO, CustomerUrlModel, ICustomerUrlModel } from "../Generated/ParticaAPI";
import ParticaCard from "@/Ui-Components/Common/Container/ParticaCardXL.vue";
import { eParticaAction, getActionName, ParticaEvent } from "../Models/ParticaEvent";
import { ButtonConfig } from "../Models/Buttons";
import ParticaAccountBase from "./Base/ParticaAccountBase.vue";
import ParticaView from "@/Ui-Components/Common/ParticaView.vue";
import { IDomainService } from "../BusinessServices/domain";
import ParticaWebsiteCard from "../Ui-Components/Domain/ParticaWebsiteCard.vue";

@Component(
	{
		name: "ParticaWebsites",
		components: { ActionListV2, ParticaCard, ParticaView, ParticaWebsiteCard }
	})
export default class ParticaWebsites extends ParticaAccountBase {
	// create or inject services
	private DomainService: IDomainService;
	@Prop() private id: number;
	private sites: ICustomerUrlModel[] = [];

	private listactions: ButtonConfig[] = [ // init our menu for the list.
		{ action: eParticaAction.WEBSITE_SELECT, label: "View" } as ButtonConfig,
		{ action: eParticaAction.WEBSITE_DELETE, label: "Remove" } as ButtonConfig
	];

	private async eventHandler(event: ParticaEvent) {
		try {
			switch (event.action) {
				case eParticaAction.WEBSITE_SELECT: {
					this.navigate("website", { id: event.item.id.toString() });
					break;
				}
				case eParticaAction.WEBSITE_DELETE: {
					throw new Error("No implmented");
					break;
				}
				default: {
					this.baseEventHandler(event);
				}

			}
		} catch (error) {
			this.ShowErrorDialog(error, `Unhandled event. ${getActionName(event.action)}`);
		}
	}



	@Watch("$route")
	private async change(to: any, from: any) {
		await this.init();
	}
	private async mounted() {
		this.metadata.name = "Websites";
		await this.init();
	}
	private async init() {
		try {
			this.LoadingStart();
			this.DomainService = this.particaServices.getDomainService();
			this.sites = await this.DomainService.getWebsites(this.id);
			await this.getAccountNav(this.id);
		} catch (error) {
			this.ShowErrorDialog(error, "error initializing component.");
		} finally {
			this.LoadingEnd();
		}
	}
}
